export const EMAIL = 'email';
export const PHONE = 'phone';